// extracted by mini-css-extract-plugin
export default {"container":"KL-z","topReviewHeading":"LL-z","criticalReview":"ML-z","favorableReview":"NL-z","vsSeparator":"OL-z"};